import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-carousel-popup',
  templateUrl: './carousel-popup.component.html',
  styleUrls: ['./carousel-popup.component.css']
})
export class CarouselPopupComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  images = this.data.images;
  currentIndex = this.data.currentIndex;
  
  next() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
  }

  selectSlide(i: number) {
    console.log(i, this.currentIndex);
    
    this.currentIndex = i;
  }

}
